import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'
import LowerNavbar from '../../learning/california/california_classes';
import Uganda from './uganda';
import Uganda_p7_subjects from './uganda_p7_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_p7 = ( ) => {
 
  return (
    <>
  <TopNavbar />
   <Uganda />
   <International_countries />
  <Uganda_p7_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_p7;
